import * as ui from '../../ui/index.js';

/**
 * Loader for HTML Templates
 * 
 * @author rhess <robin.hess@awi.de>
 */

/**
 * A function that loads the Template
 * 
 * @memberof vef.viewer.loader
 * 
 * @param {object} options 
 * @param {Viewer} viewer 
 */
export function Template(options, viewer) {
    const element = new ui.UiElement();

    // get template from DOM using ID if it starts with #
    if (options.content.startsWith("#")) {
        element.getElement().innerHTML = document.querySelector(options.content).innerHTML;
    } else {
        element.getElement().innerHTML = options.content;
    }

    viewer.addElement(options.id, element);
}
